import {Component, NgZone, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CognitoUser} from 'amazon-cognito-identity-js';
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ApiResponse} from "../../classes/api-response";
import {Constants} from "../../utils/constants";
import {environment} from "../../../environments/environment";
import { CognitoAuthService } from 'src/app/services/cognito-auth.service';

@Component({
  selector: 'aw-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  registerOTP = false;
  handler: (a: string, s: CognitoUser) => void;

  constructor(
    private httpClient: HttpClient,
    private snackBar: MatSnackBar,
    public authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
  ) {
    this.handler = this.handle.bind(this);
  }

  handle(event: string/*, a: CognitoUser*/): void {
    if (event === 'TOTPSetup') {
      this.ngZone.run(() => {
        this.registerOTP = true;
      });
    }
  }

  ngOnInit(): void {

    let redirectAfter = '';

    this.authService
      .onUserChange()
      .subscribe((user) => {
        if (!user) return;
        const url = `${environment.apiUrl}/common-user`;
        this.httpClient.get<ApiResponse>(url).toPromise().then((data) => {
          if (data.data === Constants.apiResponses.tokenExpired) redirectAfter = 'email-verification';
          else if (data.data === Constants.apiResponses.tokenValid) redirectAfter = this.authService.redirectUrl;
          this.ngZone.run(() => {
            this.router.navigate([redirectAfter]).then(() => {
            });
          });
        })
          .catch((err) => {
            this.snackBar.open("Our service is momentarily unavailable, please try again later.", undefined, {duration: 3000});
            return;
          });
      });

    // this.authService.login();

  }

}
